import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'components/ui';
import * as Styled from './General.styles';
import { Autocomplete, debounce } from "@mui/material";
import { SearchUs } from "../../../../../engine/baseApiClient";

export const General = ({ form }) => {
  
  const [usAutocompleteList, setUsAutocompleteList] = React.useState([]);
  const throttledSearchUs = React.useMemo(() => debounce((e, searchString) => { searchTaxOffice(e, searchString) }, 500), []);
  const { values, errors, setFieldValue, setFieldError, setValues } = form;

  const searchTaxOffice = async (e, searchString) => {
    if(searchString != '') {
        const searchResults = await SearchUs(searchString);
        if(searchResults.lenght === 0) searchResults.push('Brak wyników wyszukiwania');
        setUsAutocompleteList(searchResults);
    }
    else { 
        setUsAutocompleteList([]); 
    }
  }

  return (
    <Styled.Wrapper>
      <Styled.Row>
        <Autocomplete
          size="small"
          title="Wyszukaj urząd skarbowy"
          fullWidth={true}
          filterOptions={ (x) => x }
          value={values.nazwa}
          label="Nazwa"
          options={usAutocompleteList}
          autoComplete 
          filterSelectedOptions
          freeSolo
          disableClearable
          noOptionsText='Brak wyników wyszukiwania'
          renderInput={ (params)=><Styled.TextField required {...params} label="Nazwa" /> }
          onInputChange={ (event, newInputValue) => { throttledSearchUs(event, newInputValue); }}
          getOptionLabel={(value) => {
            return (typeof value === 'string') ? value : value.nazwa;
          }}
          onChange={ (event, newValue) => { 
            if(newValue != null && (typeof newValue !== 'string')) {
                setValues(newValue);                // set selected
            } else if(newValue != null && (typeof newValue === 'string')){
                setValues({ klucz: '', nazwa: ''}); // set default empty
            }
          }}
        />

        
      </Styled.Row>
    </Styled.Wrapper>
  );
};

General.propTypes = {
  form: PropTypes.object.isRequired,
  setToastData: PropTypes.func.isRequired,
  isNipDisabled: PropTypes.bool.isRequired,
};
